'use client';

import { useQuery } from '@tanstack/react-query';
import type { StorefrontMenuSnapshot } from '@/api/menu-list/storefront-menu-snapshot.types';
import type { MenuListsData } from '@/entities/cart/lib/item-price';
import {
    getStorefrontCartMenuData,
    getStorefrontItemsIndex,
    type ResolvedStorefrontItem,
} from '@/entities/product/lib/storefront-menu';
import { QueryApi } from '@/features/query/api';

export const useStorefrontSnapshot = (): StorefrontMenuSnapshot | undefined => {
    const { data } = useQuery(QueryApi.MenuList.queries.MenuLists);
    return data;
};

export const useStorefrontItemsIndex = (): Record<string, ResolvedStorefrontItem> => {
    return getStorefrontItemsIndex(useStorefrontSnapshot());
};

export const useStorefrontItem = (hash: string | null | undefined): ResolvedStorefrontItem | null => {
    const index = useStorefrontItemsIndex();
    if (!hash) return null;
    return index[hash] ?? null;
};

export const useStorefrontCartMenuData = (): MenuListsData | null => {
    return getStorefrontCartMenuData(useStorefrontSnapshot());
};
